module.exports = __webpack_public_path__ + "img/Acc-1.9776d0b7.jpg";